import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { MeasurementName } from 'core/constant/MeasurementName';
import { sendMeasurement } from 'core/messaging/measurement/measurement';

export const countImageLoadingFailures = (operationName: string, pageTypeId: ActivitiesPageTypes, srcUrl: string, activityId?: number, supplierId?: number) => {
    const measurement = buildMeasurement(operationName, MeasurementName.ImageLoadingFailure, pageTypeId);
    measurement.tags.srcUrl = srcUrl;
    measurement.tags.activityId = String(activityId);
    measurement.tags.supplierId = String(supplierId);

    sendMeasurement(measurement, pageTypeId);
};

export const countImageMissing = (operationName: string, pageTypeId: ActivitiesPageTypes, activityId?: number | string, supplierId?: number | string) => {
    const measurement = buildMeasurement(operationName, MeasurementName.ImageMissing, pageTypeId);
    measurement.tags.activityId = String(activityId);
    measurement.tags.supplierId = String(supplierId);

    sendMeasurement(measurement, pageTypeId);
};
